export default class BaseEvent {
  constructor(dataLayer = {}) {
    const defaultDataLayer = {
      event: 'event',
      event_id: null,
      category: null,
      action: null,
    };

    this.dataLayer = { ...defaultDataLayer, ...dataLayer };

    this.widgetNameSelector = 'data-widget-name';

    this.isInternational = document.documentElement.lang !== 'en';
  }

  fireEvent(customDataLayer) {
    return window.dataLayer?.push({ ...this.dataLayer, ...customDataLayer });
  }

  /* eslint-disable class-methods-use-this */
  toNormalizedString(str) {
    /*
      * - replace '&' with 'and'
      * - remove all non-alphanumeric and non-whitespace characters
      * - remove all unnecessary whitespaces and replace them with '_'
      *
      * \u0600-\u06FF - Arabic
      * \u3131-\uD79D - Korean
      * \u0E00-\u0E7F - Thai
      */
    let normalizedStr = str.replace(/&/g, 'and').replace(/\+/g, '_plus_');
    normalizedStr = normalizedStr.replace(/[^-a-z0-9_\s\u0600-\u06FF\u3131-\uD79D\u0E00-\u0E7F]+/gi, '');
    normalizedStr = normalizedStr.trim().replace(/(\s|-)/g, '_').toLowerCase();

    return normalizedStr;
  }

  getLabel($currentTarget) {
    return this.isInternational ? $currentTarget.data('enDict') || '' : $currentTarget.text();
  }
}
